<template>
  <section v-loading.fullscreen="isLoading" element-loading-text="Logging in...">
    <div class="login flex justify-center items-center" :style="{backgroundImage: 'url(' + background + ')'}">
      <div class="login-inner">
        <h1 class="login-h1">{{ appName }}</h1>
        <el-form>
          <el-input required placeholder="ホームページURL" v-model="url"></el-input>
          <el-input required placeholder="ユーザー名" v-model="username"></el-input>
          <el-input required type="password" placeholder="パスワード" v-model="password"></el-input>
          <div class=button-wrapper>
            <el-button type=primary @click="submit">Login</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Login',
  data: function () {
    return {
      isLoading: false
    }
  },
  computed: {
    appName: {
      get () { return this.$store.getters['app/name'] }
    },
    isLoggedIn: {
      get () { return this.$store.getters['wordpress/account/isLoggedIn'] }
    },
    url: {
      get () { return this.$store.getters['wordpress/account/url'] },
      set (value) { this.$store.commit('wordpress/account/url', value) }
    },
    username: {
      get () { return this.$store.getters['wordpress/account/username'] },
      set (value) { this.$store.commit('wordpress/account/username', value) }
    },
    password: {
      get () { return this.$store.getters['wordpress/account/password'] },
      set (value) { this.$store.commit('wordpress/account/password', value) }
    },
    background () {
      return require('@/assets/bg.jpg')
    }
  },
  methods: {
    submit: async function (ev) {
      this.isLoading = true
      let response = await this.$store.dispatch('wordpress/account/login')
      this.isLoading = false

      if (response && response.error) {
        let message = `${response.message}\n\n ${response.status} error: ${response.statusText}`
        switch (response.status) {
          case 403:
            message = '正しいユーザー名／パスワードを入力してください'
            break
          case 404:
            message = '正しいホームページURLを入力してください'
            break
        }
        this.$msgbox({
          title: 'ログインできませんでした',
          message,
          confirmButtonText: 'OK'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.login {
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  &-inner {
    margin: 0 auto;
    border-radius: 8px;
    padding: 2em;
    width: 90%;
    max-width: 380px;
    background-color: rgba(255,255,255,.96);
  }
  &-h1 {
    margin: .5em 0;
    font-size: 2em;
    text-align: center;
    letter-spacing: .1em;
  }
}
.el-input {
  margin: .5em 0;
  width: 100%;
}
.button {
  &-wrapper {
    margin: 1em 0 .5em;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routes/Login.vue